module.exports = __webpack_public_path__ + "static/media/gm.39ff7c3a.mp4";